import { FC, memo } from 'react';
import { useTabs } from '@hooks/common/useTabs';
import { usePricingContext } from '@pages/Pricing/context';
import styled from 'styled-components';

import Toggle from '@components/ToggleButtonGroup';

import { Indicators } from '../enums';

import BillingTab from './BillingTab/BillingTab';
import ProfileTab from './ProfileTab/ProfileTab';
import TransactionsTab from './TransactionsTab';
import { useScreenSizeContext } from '@/shared/context/ScreenSizeContext';

// Content area with dark theme styling
const ContentArea = styled.div`
  border-radius: var(--sk-radius-lg);
  border: 1px solid var(--sk-surface-border);
  background-color: var(--sk-surface-default);
  padding: var(--sk-space-6);
  margin-top: var(--sk-space-4);

  @media (max-width: 768px) {
    padding: var(--sk-space-4);
  }
`;

const ToggleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: var(--sk-space-4);
  margin-top: var(--sk-space-4);
`;

const ActiveTab: FC = () => {
  const { tab } = useTabs(Indicators.PROFILE, Indicators);
  const { period, setPeriod } = usePricingContext();
  const { isLargerScreen } = useScreenSizeContext();

  return (
    <>
      {tab === Indicators.BILLING && (
        <ToggleWrapper>
          <Toggle active={period} setActive={setPeriod} isMobile={!isLargerScreen} />
        </ToggleWrapper>
      )}
      <ContentArea>
        {tab === Indicators.PROFILE ? <ProfileTab /> : null}
        {tab === Indicators.BILLING ? <BillingTab /> : null}
        {tab === Indicators.TRANSACTIONS ? <TransactionsTab /> : null}
      </ContentArea>
    </>
  );
};

export default memo(ActiveTab);
